import { useTranslations } from '@vocab/react';
import { RadioGroup, RadioItem } from 'braid-design-system';
import type { FormEvent } from 'react';

import { usePayTypeTaxonomy } from 'src/app/shared/taxonomies/usePayTypeTaxonomy';
import type { Option } from 'src/types/formFields';

import translations from './.vocab';

export interface PayTypeProps {
  handleChange: (event: FormEvent<HTMLInputElement>) => void;
  inputValue: string;
}

export const PayType = ({ handleChange, inputValue }: PayTypeProps) => {
  const { t } = useTranslations(translations);

  const { payTypes }: { payTypes: Option[] } = usePayTypeTaxonomy();

  return (
    <RadioGroup
      id="PayTypeRadioButtonGroup"
      label={t('pay-type-label')}
      onChange={handleChange}
      value={inputValue}
      reserveMessageSpace
    >
      {payTypes.map(({ text, value }: Option, index: number) => (
        <RadioItem key={`pay-type-${index}`} label={text} value={value} />
      ))}
    </RadioGroup>
  );
};
